import {gql} from '@apollo/client';

export default gql`
  mutation updatePodlinkPodcast($input: UpdatePodlinkPodcastInput!) {
    authed {
      success
    }
    updatePodlinkPodcast(input: $input) {
      success
    }
  }
`;
